<template>
  <div>
    <!-- Page content -->
    <b-container class="mt-3 pb-3">
      <b-row class="justify-content-center">
        <b-col md="8">
          <div v-show="step == 1">
            <b-row class="justify-content-center">
              <b-col md="8">
                <b-card no-body>
                  <b-card-body>
                    <p>Please register to receive your Free Economic Model.</p>
                    <b-form @submit.prevent="submit">
                      <base-input label="First Name:"
                                  label-for="firstname"
                                  name="First Name"
                                  input-group-classes="input-group-merge"
                                  rules="required"
                                  v-model="form.firstname">
                      </base-input>
                      <base-input label="Last Name:"
                                  label-for="lastname"
                                  name="Last Name"
                                  input-group-classes="input-group-merge"
                                  rules="required"
                                  v-model="form.lastname">
                      </base-input>
                      <base-input label="Email:"
                                  label-for="email"
                                  type="email"
                                  name="Email"
                                  input-group-classes="input-group-merge"
                                  rules="required"
                                  v-model="form.email">
                      </base-input>
                      <base-input label="Phone:"
                                  label-for="phone"
                                  name="Phone"
                                  input-group-classes="input-group-merge"
                                  rules="required"
                                  v-model="form.phone">
                      </base-input>
                      <base-input label="How do you currently track your data?"
                                  label-for="current_tracking_system"
                                  name="Current Tracking System"
                                  input-group-classes="input-group-merge"
                                  rules="required"
                                  v-model="form.current_tracking_system">
                      </base-input>
                      <base-input label="Do you currently have a coach?" label-for="being_coached" name="Being Coached">
                        <el-select v-model="form.being_coached">
                          <el-option label="Yes" value="Yes"></el-option>
                          <el-option label="No" value="No"></el-option>
                        </el-select>
                      </base-input>
                      <b-button block variant="danger" type="submit">Submit</b-button>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
          <div v-show="step == 2">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>What is your goal?</h3>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input label="Agent Status:" label-for="team_member" name="Agent Status">
                  <el-select v-model="cos.team_member">
                    <el-option v-for="(type, index) in teamTypes"
                               :key="index"
                               :label="type.text"
                               :value="type.value">
                    </el-option>
                  </el-select>
                </base-input>
                <base-input label="Net Profit Goal:"
                            label-for="net_profit_goal"
                            name="Net Profit Goal"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            v-model="economicModel.net_profit_goal"
                            @focus="$event.target.select()">
                </base-input>
                <base-input label="Average Sale Price:"
                            label-for="avg_sale_price"
                            name="Average Sale Price"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            v-model="economicModel.avg_sale_price"
                            @focus="$event.target.select()">
                </base-input>
                <base-input label="Average Commission Percent"
                            label-for="avg_commission_percent"
                            name="Average Commission Percent"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="economicModel.avg_commission_percent"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label">Average Commission %: <span id="avg-commission-percent"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="avg-commission-percent" triggers="hover" variant="danger">
                      If unsure, input 2.85. This can be edited in the portal.
                    </b-tooltip>
                  </template>
                  <template #helperText><small class="text-muted">What will be the average commission % that you earn on each transaction?</small></template>
                </base-input>

                <label class="form-control-label">Average Commission: {{ averageCommission | currency }}</label>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="next" class="float-right">Listing Information <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 3">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Listing Information</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401060?h=bd0a65bbae', 'Listings Taken %')">Listings Taken %</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401049?h=a1625be90d', 'Listings Taken to Close %')">Listings Taken to Close %</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401039?h=62116a4fa6', '% of Business From Listings')">% of Business From Listings</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input label="Listings Taken %:"
                            label-for="listings_taken_percent"
                            name="Listings Taken %"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="economicModel.listings_taken_percent"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label">Listings Taken %: <span id="listings-taken-percent"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="listings-taken-percent" triggers="hover" variant="danger">
                      If unsure, input 70%. This can be edited in the portal.
                    </b-tooltip>
                  </template>
                  <template #helperText><small class="text-muted">What % of listing appointments that you go on will you get signed?</small></template>
                </base-input>
                <base-input label="Listings Taken to Close %:"
                            label-for="listings_taken_to_close"
                            name="Listings Taken to Close %"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="economicModel.listings_taken_to_close"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label">Listings Taken to Close %: <span id="listings-taken-to-close"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="listings-taken-to-close" triggers="hover" variant="danger">
                      If unsure, input 90%. This can be edited in the portal.
                    </b-tooltip>
                  </template>
                </base-input>
                <b-form-text class="mt--4 mb-3">What % of listings that you take will result in a closing?</b-form-text>
                <base-input label="% of Business From Listings:"
                            label-for="percent_of_business"
                            name="% of Business From Listings"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="economicModel.percent_of_business"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label">% of Business From Listings: <span id="percent-of-business"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="percent-of-business" triggers="hover" variant="danger">
                      If unsure, input 50%. This can be edited in the portal.
                    </b-tooltip>
                  </template>
                  <template #helperText><small class="text-muted">What % of your closed business will be from listings?</small></template>
                </base-input>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 1"><i class="fas fa-angle-double-left"></i> What is your goal?</base-button>
                    <base-button variant="danger" @click="next" class="float-right">Buyer Information <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 4">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Buyer Information</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401028?h=ca5c7d761a', 'Buyers Taken %')">Buyers Taken %</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401019?h=49548186b4', 'Buyers Taken to Close %')">Buyers Taken to Close %</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input label="Buyers Taken %:"
                            label-for="buyers_taken_percent"
                            name="Buyers Taken %"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="economicModel.buyers_taken_percent"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label">Buyers Taken %: <span id="buyers-taken-percent"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="buyers-taken-percent" triggers="hover" variant="danger">
                      If unsure, input 70%. This can be edited in the portal.
                    </b-tooltip>
                  </template>
                  <template #helperText><small class="text-muted">What % of buyer appointments that you go on will you get signed?</small></template>
                </base-input>
                <base-input label="Buyers Taken to Close %:"
                            label-for="listings_taken_to_close"
                            name="Buyers Taken to Close %"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="economicModel.buyers_taken_to_close"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label">Buyers Taken to Close %: <span id="buyers-taken-to-close"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="buyers-taken-to-close" triggers="hover" variant="danger">
                      If unsure, input 70%. This can be edited in the portal.
                    </b-tooltip>
                  </template>
                  <template #helperText><small class="text-muted">What % of Buyers that you sign will result in a closing?</small></template>
                </base-input>

                <label class="form-control-label">% of Business From Buyers: {{ 100 - economicModel.percent_of_business }}%</label>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 1"><i class="fas fa-angle-double-left"></i> Listing Information</base-button>
                    <base-button variant="danger" @click="next" class="float-right">Estimate your Annual Expenses <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 5">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Estimate your Annual Expenses</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401013?h=47b0cc83f7', 'Monthly Expenses')">Monthly Expenses</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input label="On average, how much do intend to spend on your business per month?"
                            label-for="monthly_expenses"
                            name="Monthly Expenses"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            v-model="cos.monthly_expenses"
                            @focus="$event.target.select()">
                </base-input>

                <label class="form-control-label">Your Total Annual Expenses will be approximately... {{ cos.monthly_expenses * 12 | currency }}</label>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 1"><i class="fas fa-angle-double-left"></i> Buyer Information</base-button>
                    <base-button variant="danger" @click="next" class="float-right">Calculate Your Cost of Sale <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 6">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Calculate Your Cost of Sale</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742401005?h=1431e35a47', 'Max Paid to Broker')">Max Paid to Broker</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400964?h=675ac9ef56', 'Max Paid to Franchise')">Max Paid to Franchise</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <h4 class="text-danger">The following Cost of Sale Calculator is to calculate your ANNUAL Cost of Sale.</h4>
                <base-input label="Is there a maximum amount you pay your broker per year?" 
                            label-for="units">
                  <base-switch class="mr-1" v-model="cos.broker_yearly_max"></base-switch>
                </base-input>
                <base-input name="Broker Dollar Max"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            rules="required"
                            v-model="cos.broker_dollar_max"
                            v-if="cos.broker_yearly_max"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label" label-for="broker_dollar_max">What is the maximum dollar amount you will pay your broker?</label>
                  </template>
                  <template #prepend><i class="fas fa-dollar-sign"></i></template>
                </base-input>
                <base-input name="Broker %"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            rules="required"
                            v-model="cos.broker_percent"
                            @focus="$event.target.select()"
                            v-else>
                  <template #label>
                    <label class="form-control-label" label-for="broker_dollar_max">What % of your commissions go to your broker?</label>
                  </template>
                  <template #append><i class="fas fa-percent"></i></template>
                </base-input>
                <base-input label="Does your company have an annual Franchise Fee in addition to your broker split?" 
                            label-for="franchise_fee">
                  <base-switch class="mr-1" v-model="cos.franchise_fee"></base-switch>
                </base-input>
                <base-input label="What is your annual Franchise Fee?"
                            label-for="annual_franchise_fee"
                            name="Annual Franchise Fee"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            v-model="cos.annual_franchise_fee"
                            @focus="$event.target.select()"
                            v-if="cos.franchise_fee">
                </base-input>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 1"><i class="fas fa-angle-double-left"></i> Estimate Expenses</base-button>
                    <base-button variant="danger" @click="individualAgent" class="float-right" v-if="cos.team_member == 2">Next Cost of Sale <i class="fas fa-angle-double-right"></i></base-button>
                    <base-button variant="danger" @click="next" class="float-right" v-else>Next Cost of Sale <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 7">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Calculate Your Cost of Sale</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400942?h=f8f4e64ec0', 'Rainmaker Listings')">Rainmaker Listings</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400952?h=27db4d5dbc', 'Rainmaker Buyers')">Rainmaker Buyers</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400991?h=2f26be2bd3', 'Split on Listings')">Split on Listings</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400975?h=1f574c9b10', 'Split on Buyers')">Split on Buyers</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input name="Listings Sold"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            rules="required"
                            v-model="cos.listings_sold"
                            @focus="$event.target.select()"
                            v-if="cos.team_member == 0">
                  <template #label>
                    <label class="form-control-label">How many listings will you personally sell? <span id="listings-sold-tooltip"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="listings-sold-tooltip" triggers="hover" variant="danger">
                      How many listings will you sell where there will be no split paid out. Note: If you pay yourself a split as the rainmaker enter 0.
                    </b-tooltip>
                  </template>
                </base-input>
                <base-input name="Buyers Sold"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            rules="required"
                            v-model="cos.buyers_sold"
                            @focus="$event.target.select()"
                            v-if="cos.team_member == 0">
                  <template #label>
                    <label class="form-control-label">How many buyers will you personally sell? <span id="buyers-sold-tooltip"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="buyers-sold-tooltip" triggers="hover" variant="danger">
                      How many buyers will you sell where there will be no split paid out. Note: If you pay yourself a split as the rainmaker enter 0.
                    </b-tooltip>
                  </template>
                </base-input>
                <base-input name="Listings Commission"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="cos.listings_commission_percent"
                            @focus="$event.target.select()"
                            v-if="cos.team_member !== 2">
                  <template #label>
                    <label class="form-control-label" label-for="listings_commission_percent" v-if="cos.team_member == 0">On average, what % do you pay to Team Members on Listing Sales</label>
                    <label class="form-control-label" label-for="listings_commission_percent" v-else>On average, what is your split percentage you will you be paid on from your team on Listing Sales</label>
                  </template>
                </base-input>
                <base-input label="On average, what % do you pay to Team Members on Buyers Sales"
                            label-for="buyers_commission_percent"
                            name="Buyers Commission"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="cos.buyers_commission_percent"
                            @focus="$event.target.select()"
                            v-if="cos.team_member !== 2">
                  <template #label>
                    <label class="form-control-label" label-for="buyers_commission_percent" v-if="cos.team_member == 0">On average, what % do you pay to Team Members on Buyers Sales</label>
                    <label class="form-control-label" label-for="buyers_commission_percent" v-else>On average, what is your split percentage you will you be paid on from your team on Buyers Sales</label>
                  </template>
                </base-input>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 1"><i class="fas fa-angle-double-left"></i> Previous Cost of Sale</base-button>
                    <base-button variant="danger" @click="next" class="float-right">Next Cost of Sale <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 8">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Calculate Your Cost of Sale</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400928?h=ed6968b944', 'ISA Fees')">ISA Fees</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400935?h=2789b34dc1', 'Referral Fees')">Referral Fees</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input>
                  <template #label>
                    <label class="form-control-label" label-for="isa">Do you have an ISA Department? <span id="isa-tooltip"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="isa-tooltip" triggers="hover" variant="danger">
                      Inside Sales Agent - Someone that prospects on the companies behalf setting listing and buyer appointments that is paid a commission % at closing
                    </b-tooltip>
                  </template>
                  <base-switch class="mr-1" v-model="cos.isa"></base-switch>
                </base-input>
                <base-input label="What % of total sales will ISA's be paid on?"
                            label-for="isa_percent_total"
                            name="ISA % Total"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="cos.isa_percent_total"
                            @focus="$event.target.select()"
                            v-if="cos.isa">
                </base-input>
                <base-input label="On average, what % does an ISA get paid on each closing?"
                            label-for="isa_percent"
                            name="ISA %"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="cos.isa_percent"
                            @focus="$event.target.select()"
                            v-if="cos.isa">
                </base-input>
                <hr />
                <base-input name="Referral Fees"
                            type="number"
                            step="0.01"
                            min="0"
                            rules="required"
                            v-model="cos.referral_fee_count"
                            @focus="$event.target.select()">
                  <template #label>
                    <label class="form-control-label" label-for="referral_fee_count">
                      <label class="form-control-label">How many referral fees in units do you intend to pay out in {{ year }}? <span id="referral-fee-tooltip"><i class="fas fa-question-circle"></i></span></label>
                      <b-tooltip target="referral-fee-tooltip" triggers="hover" variant="danger">
                        Your company paying a referral fee to another brokerage at the closing of your sale
                      </b-tooltip>
                    </label>
                  </template>
                </base-input>
                <base-input label="On average, what referral fee % will you pay?"
                            label-for="referral_fee_percent"
                            name="Referral Fee %"
                            type="number"
                            step="0.01"
                            min="0"
                            max="100"
                            input-group-classes="input-group-merge"
                            appendIcon="fas fa-percent"
                            rules="required"
                            v-model="cos.referral_fee_percent"
                            @focus="$event.target.select()">
                </base-input>

                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 2" v-if="cos.team_member == 2"><i class="fas fa-angle-double-left"></i> Previous Cost of Sale</base-button>
                    <base-button variant="danger" @click="step = step - 1" v-else><i class="fas fa-angle-double-left"></i> Previous Cost of Sale</base-button>
                    <base-button variant="danger" @click="next" class="float-right">Next Cost of Sale <i class="fas fa-angle-double-right"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <div v-show="step == 9">
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3>Calculate Your Cost of Sale</h3>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400913?h=09bf631b9c', 'Admin Fees')">Admin Fees</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742400919?h=5c23e05e63', 'Additional Cost of Sale')">Additional Cost of Sale</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <b-card-body>
                <base-input label="Do you pay a transaction fee to an admin on each closed listing?" label-for="transactions_fee">
                  <base-switch class="mr-1" v-model="cos.transaction_fee"></base-switch>
                </base-input>
                <base-input label="How much do you pay an admin on each closing?:"
                            label-for="transaction_fee_amount"
                            name="Listing Transaction Fee"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            v-model="cos.transaction_fee_amount"
                            @focus="$event.target.select()"
                            v-if="cos.transaction_fee">
                </base-input>
                <base-input label="Do you pay a transaction fee to an admin on each closed buyer?" label-for="buyer_transaction_fee">
                  <base-switch class="mr-1" v-model="cos.buyer_transaction_fee"></base-switch>
                </base-input>
                <base-input label="How much do you pay an admin on each closing?:"
                            label-for="buyer_transaction_fee_amount"
                            name="Buyer Transaction Fee"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            v-model="cos.buyer_transaction_fee_amount"
                            @focus="$event.target.select()"
                            v-if="cos.buyer_transaction_fee">
                </base-input>
                <base-input name="Additional Annual Cost Of Sale"
                            type="number"
                            step="0.01"
                            min="0"
                            input-group-classes="input-group-merge"
                            prependIcon="fas fa-dollar-sign"
                            rules="required"
                            @focus="$event.target.select()"
                            v-model="cos.additional_cos">
                  <template #label>
                    <label class="form-control-label">Any Estimated Additional Annual Cost of Sale <span id="additional-cos-tooltip"><i class="fas fa-question-circle"></i></span></label>
                    <b-tooltip target="additional-cos-tooltip" triggers="hover" variant="danger">
                      Are there any other costs you will incur when this transaction closes? I.E. Paying for a Home Warranty at closing, paying for inspection repairs at closing, etc.?
                    </b-tooltip>
                  </template>
                </base-input>
                <b-row>
                  <b-col>
                    <base-button variant="danger" @click="step = step - 1"><i class="fas fa-angle-double-left"></i> Previous Cost of Sale</base-button>
                    <base-button variant="success" @click="next" class="float-right">Complete <i class="fas fa-check"></i></base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
        </b-col>
        <b-col md="4" v-if="step > 1 && step <= 9">
          <economic-model-overview :year="year" :economicModel="economicModel" :cos="cos"></economic-model-overview>
        </b-col>
      </b-row>
      <b-row v-show="step == 10">
        <b-col md="12">
          <economic-model-overview :year="year" :economicModel="economicModel" :cos="cos" @startOver="step = 2" :step="step"></economic-model-overview>
        </b-col>
        <b-col md="4">
        </b-col>
      </b-row>
    </b-container>
    <how-to-modal :source="howToVideo" :video_title="howToTitle"></how-to-modal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import economicModelMixin from '@/mixins/economicModel-mixin';
import {Select, OptionGroup, Option} from 'element-ui';
import economicModelOverview from './EconomicModelOverview';
import HowToModal from '@/views/Components/Modals/HowToModal';

export default {
  mixins: [economicModelMixin],
  components: {
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option,
    economicModelOverview,
    HowToModal
  },
  data() {
    return {
      form: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        current_tracking_system: '',
        being_coached: null
      },
      step: 1,
      teamTypes: [
        { value: 0, text: "I own a team - Have additional sales people" },
        { value: 1, text: "I'm on a team" },
        { value: 2, text: "I'm an individual agent - No additional sales people" },
      ],
      year: new Date().getFullYear(),
      howToVideo: null,
      howToTitle: null,
    }
  },
  computed: {

  },
  methods: {
    async next() {
      this.economicModel.cos = this.calculatedCos;
      this.economicModel.cos = this.calculatedCos;
      this.economicModel.cos = this.calculatedCos;
      this.step = this.step + 1;

      if (this.step == 10) {
        this.$store.commit('demo/SET_COMPLETED_RESOURCE', true);
        this.$store.commit('demo/SET_ECONOMIC_MODEL_RESOURCE', this.economicModel);
        this.$store.commit('demo/SET_COS_RESOURCE', this.cos);
      }
    },
    checkDemo() {
      let complete = this.$store.getters['demo/completed'];
      let registered = this.$store.getters['demo/registered'];

      if (registered) {
        this.registered = true;
        this.step = 2;
      }

      if (complete) {
        this.economicModel = this.$store.getters['demo/economicModel'];
        this.cos = this.$store.getters['demo/cos'];
        this.step = 10;
      }
    },
    startHowTo(video, title) {
      this.howToVideo = video;
      this.howToTitle = title;
      this.$bvModal.show('how-to-modal');
    },
    submit() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/leads", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Enjoy your free Economic Model',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$store.commit('demo/SET_REGISTERED_RESOURCE', true);
          this.next();
        });
      })
      .catch(error => {
        // error
      });
    }
  },
  watch: {
    calculatedCos(to, from) {
      this.economicModel.cos = to;
    }
  },
  created() {
    this.checkDemo();
  }
};
</script>
<style lang="scss">
body {
  background-color: #ffffff;
}

#hubspot-messages-iframe-container {
  display: none !important;
}

#hubspot-conversations-iframe {
  display: none !important;
}
</style>